module.exports = __webpack_public_path__ + "img/28.aae61e68.png";